import React from "react";
import { AppExperimentProvider } from "@catchoftheday/analytics";
import { getEnvConfig, withEnvConfig } from "@catchoftheday/env-config";
import { withApollo } from "@catchoftheday/graphql-utils";
import { jsx as ___EmotionJSX } from "@emotion/react";

function HeaderApp(_ref) {
  var Component = _ref.Component,
      pageProps = _ref.pageProps;
  return ___EmotionJSX(AppExperimentProvider, null, ___EmotionJSX(Component, pageProps));
}

export default withEnvConfig(withApollo({
  uri: function uri() {
    return getEnvConfig().GRAPHQL_ENDPOINT;
  }
})(HeaderApp));